(function () {
  const root = document.querySelector('[data-milestones]');
  if (!root) return;

  let STEPS = [];
  try { STEPS = JSON.parse(root.dataset.steps); } catch (e) { STEPS = []; }
  if (!STEPS.length) return;
  STEPS.sort((a, b) => a.at - b.at);

  const text = root.querySelector('[data-ms-text]');
  const fill = root.querySelector('[data-ms-fill]');
  const track = root.querySelector('[data-ms-track]');
  const money = (c) => '$' + (c / 100).toFixed(2).replace(/\.00$/, '');
  const N = STEPS.length;
  const tpl = root.querySelector('[data-ms-icons]');
  const icons = tpl ? Array.from(tpl.content.children).map((el) => el.innerHTML) : [];

  // marks sit at equal spacing along the bar; progress is linear between them
  const marks = STEPS.map((s, i) => {
    const m = document.createElement('span');
    m.className = 'ms__mark';
    m.style.left = ((i + 1) / N) * 100 + '%';
    m.innerHTML = '<i>' + money(s.at) + '</i>' + (icons[s.i != null ? s.i : i] || '');
    track.appendChild(m);
    return m;
  });

  let cartTotal = Number(root.dataset.total) || 0;
  let pending = Number(window.__mixPending) || 0;
  // Closing the bar hides it only until the cart total changes (adding candy, a bag, a gift), so it never stays gone for good.
  // A small "progress" button stays at the bottom to bring it back at any time.
  let dismissedAt = null;
  try { const v = sessionStorage.getItem('ms-dismissed-at'); if (v !== null) dismissedAt = Number(v); } catch (e) {}
  const reopen = document.createElement('button');
  reopen.type = 'button';
  reopen.className = 'ms-reopen';
  reopen.textContent = 'Shipping & gift progress';
  reopen.hidden = true;
  document.body.appendChild(reopen);
  let lastTotal = 0;

  // Phones: the small "Shipping & gift progress" button is the resting state. The full bar opens when something is added to (or removed
  // from) the cart, or when the button is tapped, and STAYS open (also on the next page) until the x is pressed, which folds it back into the button.
  const phone = window.matchMedia('(max-width: 749px)');
  let phoneOpen = false;
  try { phoneOpen = sessionStorage.getItem('ms-phone-open') === '1'; } catch (e) {}
  const setPhoneOpen = (v) => { phoneOpen = v; try { sessionStorage.setItem('ms-phone-open', v ? '1' : '0'); } catch (e) {} };
  let lastCartTotal = null;

  function render(total, fromCart) {
    let pct = 100;
    for (let i = 0; i < N; i++) {
      if (total < STEPS[i].at) {
        const lo = i === 0 ? 0 : STEPS[i - 1].at;
        pct = ((i + (total - lo) / (STEPS[i].at - lo)) / N) * 100;
        break;
      }
    }
    fill.style.width = pct + '%';
    track.setAttribute('aria-valuenow', Math.round(pct));
    const nextIdx = STEPS.findIndex((s) => total < s.at);
    marks.forEach((m, i) => { m.classList.toggle('is-hit', total >= STEPS[i].at); m.classList.toggle('is-next', i === nextIdx); });
    const next = STEPS.find((s) => total < s.at);
    // phones: shorter words so the narrow bar stays small
    const ph = window.matchMedia('(max-width: 749px)').matches;
    text.textContent = next
      ? money(next.at - total) + (ph ? ' to ' : ' away from ') + (ph ? next.msg.replace('a free ', '') : next.msg)
      : (ph ? 'Everything unlocked!' : 'Everything unlocked: shipping and all gifts');
    lastTotal = total;
    if (phone.matches) {
      if (fromCart) {
        if (lastCartTotal !== null && cartTotal !== lastCartTotal) setPhoneOpen(true);
        lastCartTotal = cartTotal;
      }
      root.hidden = !phoneOpen;
      reopen.hidden = phoneOpen;
      return;
    }
    const isDismissed = dismissedAt !== null && dismissedAt === total;
    root.hidden = isDismissed;
    reopen.hidden = !isDismissed;
  }

  // Sum of everything that counts toward a milestone: gifts never count. It is the AFTER-discount amount (flash deals and other
  // automatic discounts, plus any discount code already applied to the cart), because Shopify checks the free-shipping and
  // free-gift minimums against what the customer actually pays, so the bar shows what they will really unlock.
  function qualifyingTotal(cart) {
    // wholesale cases have their own shipping (free at $250) and no gifts: a cart with cases counts for nothing here
    if (cart.items.some((i) => /-swedish-candy-\d+-pack$/.test(i.handle || ''))) return 0;
    const lines = cart.items
      .filter((i) => !(i.properties && i.properties._free_gift))
      .reduce((sum, i) => sum + i.final_line_price, 0);
    const cartLevel = (cart.cart_level_discount_applications || []).reduce((sum, d) => sum + (d.total_allocated_amount || 0), 0);
    return Math.max(0, lines - cartLevel);
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => {
        cartTotal = qualifyingTotal(c);
        render(cartTotal + pending, true);
        window.dispatchEvent(new CustomEvent('cart:synced', { detail: { cart: c, qualifying: cartTotal } }));
      })
      .catch(() => {});
  }
  window.refreshMilestones = refresh;

  root.querySelector('[data-ms-close]').addEventListener('click', () => {
    if (phone.matches) { setPhoneOpen(false); root.hidden = true; reopen.hidden = false; return; }
    dismissedAt = lastTotal;
    root.hidden = true;
    reopen.hidden = false;
    try { sessionStorage.setItem('ms-dismissed-at', String(dismissedAt)); } catch (e) {}
  });
  reopen.addEventListener('click', () => {
    if (phone.matches) { setPhoneOpen(true); root.hidden = false; reopen.hidden = true; return; }
    dismissedAt = null;
    root.hidden = false;
    reopen.hidden = true;
    try { sessionStorage.removeItem('ms-dismissed-at'); } catch (e) {}
  });

  // The header "Cart 0" pill is drawn by the server, so after anything is added, changed or cleared (from any page, any button)
  // ask for the fresh pill and drop it in. One place, so every add button on the site keeps the count right.
  function refreshPill() {
    origFetch('/?sections=cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((data) => {
        const html = new DOMParser().parseFromString(data['cart-icon-bubble'] || '', 'text/html');
        const src = html.querySelector('.shopify-section');
        const dst = document.getElementById('cart-icon-bubble');
        if (src && dst) dst.innerHTML = src.innerHTML;
      })
      .catch(() => {});
  }

  const origFetch = window.fetch;
  window.fetch = function (input) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(() => setTimeout(() => { refresh(); refreshPill(); }, 150), () => {});
    return p;
  };

  window.addEventListener('mix:pending', (e) => { pending = (e.detail && e.detail.cents) || 0; render(cartTotal + pending); });
  window.addEventListener('pageshow', refresh);

  render(cartTotal + pending);
  refresh();
})();
